export const steps = [
  {
    title: 'Dado de pagamento de frete',
    description:
      'Cadastre os CNPJs ou CPFs que você usa para pagar motoristas.',
    icon: 'billing',
  },
  {
    title: 'Registro automático de viagem',
    description:
      'Criamos a viagem quando você pagar na Conta Fretebras do Motorista.',
    icon: 'trip',
  },
  {
    title: 'Monitoramento da viagem',
    description:
      'Acompanhe o motorista e sua carga o dia todo, de maneira fácil e segura.',
    icon: 'travel-map',
  },
];
